import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "../../abstract.component";
import {LeagueCompetitorMatchingData} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {League, LeagueCompetitor, MatchStatus} from "@model";

@Component({
  selector: 'app-competitor-match-details-modal',
  templateUrl: './competitor-match-details-modal.component.html',
  styleUrl: './competitor-match-details-modal.component.scss',
  standalone: false
})
export class CompetitorMatchDetailsModalComponent extends AbstractComponent{
  @Input() matchingData?: LeagueCompetitorMatchingData;
  @Input() league: League | undefined;
  @Input() raceNames: Map<number, string> = new Map<number, string>();
  @Output() onSave: EventEmitter<LeagueCompetitor[]> = new EventEmitter<LeagueCompetitor[]>();


  selectionMap: Map<number, boolean> = new Map<number, boolean>();
  saveDisabled: boolean = true;

  constructor(public translocoService: TranslocoService,
              public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
    if (this.matchingData?.matchedTo){
      this.selectionMap.set(this.matchingData!.matchedTo?.id!, true);
    }
    if (this.matchingData?.matchedFrom?.length) {
      this.matchingData.matchedFrom.forEach(m => {
        this.selectionMap.set(m.id!, true)
      })
    }
  }

  onClose(): void {
    this.activeModal.dismiss();
  }

  onConfirm() {
    let resultList: LeagueCompetitor[] = [];
    if (this.matchingData?.matchedTo) {
      resultList.push(this.matchingData.matchedTo)
    }
    if (this.matchingData?.matchedFrom?.length) {
      resultList.push(...this.matchingData.matchedFrom);
    }
    resultList = resultList.filter(c => !this.selectionMap.get(c.id!));
    if (resultList.length) {
      this.onSave.emit(resultList);
    }
  }

  onUnlink(id: number) {
    this.selectionMap.set(id, !this.selectionMap.get(id));
    this.saveDisabled = ![...this.selectionMap.values()].includes(false);
  }

  protected readonly MatchStatus = MatchStatus;


}
